/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ThumbsDownRow } from './thumbsDownRow';

export interface ThumbsDownList {
  items?: ThumbsDownRow[];
}
